module.exports = __webpack_public_path__ + "img/rocket.452cc3c0.svg";